export default {
  custom: () => import("/opt/buildhome/repo/layouts/custom.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  new: () => import("/opt/buildhome/repo/layouts/new.vue").then(m => m.default || m)
}